// Texts of the percentile trends: a point's text is shared by the Percentiles chart's hover and the percentile items panel's title
import moment from 'moment';
import pluralize from 'pluralize';

import { formatDateSpan } from './dates';

const TITLE_FORMATS = { month: 'MMMM YYYY', quarter: '[Q]Q YYYY' };

export function percentileGroupText({ periodStart, first, last, count, incomplete }, { trendsBy, trendsPeriod }) {
  const items = pluralize('completed item', count, true);
  const span = formatDateSpan(moment(first), moment(last));

  if (trendsBy === 'items') {
    return { title: items, aboveRows: [`Completed ${span}`], belowRows: [] };
  }

  const showSpan = incomplete || trendsPeriod === 'week';

  return {
    title: showSpan ? span : moment(periodStart).format(TITLE_FORMATS[trendsPeriod]),
    aboveRows: [items],
    belowRows: incomplete ? [`Incomplete ${trendsPeriod}`] : []
  };
}
